// searchReducer.js
import { 
  SET_DATE_SELECTED,
  SET_SEARCH_TYPE, 
  SET_SEARCH_TEXT, 
  SET_SEARCH_TEXT_VALUE, 
  SET_CLEAR_FILTER_SEARCH, 
  SET_HOT_LEAGUE_SEARCH, 
  SET_LEAGUE_SEARCH, 
  SET_TEAM_SEARCH, 
  SET_MATCH_SEARCH, 
  SET_COUNTRY_SEARCH,
  SET_CLEAR_HOT_LEAGUE_SEARCH,
  SET_FILTER_LEAGUE,
  SET_FILTER_LEAGUE_TYPE,
  SET_FILTER_ROUND,
  SET_FILTER_DATE,
  SET_FILTER_ROUND_NAME,
} from './actionTypes';
import { searchText } from './initialState';
const INITIAL_STATE = {
  dateSelected: '',
  searchType: '',
  searchText: '',
  searchTextValue: '',
  leagueSearch: '',
  hotLeagueSearch: '',
  teamSearch: '',
  matchSearch: '',
  countrySearch: '',
  clearStatus: false,
  clearHotLeagueSearch: true,
  filterLeague: '',
  filterLeagueType: '',
  filterRound: '',
  filterRoundName: '',
  filterDate: '',
}

const SearchReducer = (state: String = searchText, action: any) => {
  switch (action.type) {
    case SET_DATE_SELECTED:
      return { ...state, dateSelected: action.payload };
    case SET_SEARCH_TEXT:
      return { ...state, searchText: action.payload };
    case SET_SEARCH_TEXT_VALUE:
      return { ...state, searchTextValue: action.payload };
    case SET_SEARCH_TYPE:
      return { ...state, searchType: action.payload };
    case SET_LEAGUE_SEARCH:
      return { ...state, leagueSearch: action.payload };
    case SET_HOT_LEAGUE_SEARCH:
      return { ...state, hotLeagueSearch: action.payload };
    case SET_TEAM_SEARCH:
      return { ...state, teamSearch: action.payload };
    case SET_MATCH_SEARCH:
      return { ...state, matchSearch: action.payload };
    case SET_COUNTRY_SEARCH:
      return { ...state, countrySearch: action.payload };
    case SET_CLEAR_FILTER_SEARCH:
      return { ...state, clearStatus: action.payload };
    case SET_CLEAR_HOT_LEAGUE_SEARCH:
      return { ...state, clearHotLeagueSearch: action.payload };  
    case SET_FILTER_LEAGUE:
      return { ...state, filterLeague: action.payload };  
    case SET_FILTER_LEAGUE_TYPE:
      return { ...state, filterLeagueType: action.payload };  
    case SET_FILTER_ROUND:
      return { ...state, filterRound: action.payload };  
    case SET_FILTER_ROUND_NAME:
      return { ...state, filterRoundName: action.payload };  
    case SET_FILTER_DATE:
      return { ...state, filterDate: action.payload };  
    default:
      return state;
  }
};

export default SearchReducer;
